import { InjectionToken } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { EarlyPayoutAcceptance } from '@frontend/sports/user/feature';

import { IBetslipState } from '../../../../../base/store/state';
import { IBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';

export interface IBetslipValidationComposer {
    validateBetslip(betslip: IBetslip, state: IBetslipState, acceptance: Nullable<EarlyPayoutAcceptance>): BetslipError[];
}

export const BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN = new InjectionToken<IBetslipValidationComposer>(
    'BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN',
);
